import { Box, Flex, Text } from '@chakra-ui/react';
import { storageComponentSx } from 'app/components/Storage/styles';
import { LegendItemProps, StorageItem } from '../types';

const LegendItem = ({ children, color, ...rest }: LegendItemProps) => {
  return (
    <Flex alignItems="center" {...rest}>
      <Box bg={color} borderRadius="50%" width={2} height={2} mr={1} />
      <Text fontSize="2xs" color="M.60" mt={1}>
        {children}
      </Text>
    </Flex>
  );
};

interface StorageLegendProps {
  usedPersonal: StorageItem;
  usedShared: StorageItem;
}

export const StorageLegend = ({
  usedPersonal,
  usedShared,
}: StorageLegendProps) => {
  return (
    <Flex
      width="100%"
      flexWrap="wrap"
      data-testid="storage-legend"
      sx={storageComponentSx.storageLegend}
    >
      <LegendItem color="B.80" mr={4} data-testid="storage-legend-personal">
        Your audio: {usedPersonal.value} {usedPersonal.unit}
      </LegendItem>
      <LegendItem color="V.80" data-testid="storage-legend-shared">
        Collaborator audio: {usedShared.value} {usedShared.unit}
      </LegendItem>
    </Flex>
  );
};
